(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["harmony-subscription"] && !Shopify.designMode) return;
  try {
    document.addEventListener('variant:change', function(evt) {
  let variant = evt.detail.variant;
  if (variant) {
    const discount_percentage_top = document.getElementById('discount_percentage_top').value;
const onetime_discount_percentage_top = document.getElementById('onetime_discount_percentage_top')?.value || 1;    
    let newPrice = (variant.price / 100).toFixed(2); // Convert cents to dollars
    let formattedPrice = newPrice.replace(/\.00$/, ''); // Remove trailing .00 if needed

    let newOneTimePrice = (variant.price / 100 * onetime_discount_percentage_top).toFixed(2); // Convert cents to dollars
    let formattedOneTimePrice = newOneTimePrice.replace(/\.00$/, ''); // Remove trailing .00 if needed

    let newSubscriptionPrice = (variant.price / 100 * discount_percentage_top).toFixed(2); // Convert cents to dollars
    let formattedSubscriptionPrice = newSubscriptionPrice.replace(/\.00$/, ''); // Remove trailing .00 if needed

    // Update the HTML content
    let priceContainer = document.querySelector('.one-time-price span.product__price--compare');
    if (priceContainer) {
      priceContainer.textContent = `₪${formattedPrice}`;
    }

    // Update the HTML content - newPrice
let newPriceContainer = document.querySelector('.one-time-price span.product__price') || document.querySelector('.one-time-price span');    if (newPriceContainer) {
      newPriceContainer.textContent = `₪${formattedOneTimePrice}`;
    }
    
    let priceSubContainerComp = document.querySelector('.subscription-price .product__price--compare');
    if (priceSubContainerComp) {
      priceSubContainerComp.textContent = `₪${formattedPrice}`;
    }

    let priceSubContainer = document.querySelector('.subscription-price .product__price');
    if (priceSubContainer) {
      priceSubContainer.textContent = `₪${formattedSubscriptionPrice}`;
    }

    let titleContainer = document.querySelector('.subscription-nospace .title strong');
    if (titleContainer) {
      let variantId = variant.id;
      let variantInput = document.querySelector(`input[data-variant-id="${variantId}"]`);
      if (variantInput) {
        let subscriptionTime = variantInput.getAttribute('data-subscription-time');
        titleContainer.textContent = subscriptionTime;
      } else {
        titleContainer.textContent = variant.title;
      }
    }
  }
});
document.querySelectorAll('input[name="properties[תדירות]"]').forEach(function(radio) {
  radio.addEventListener('change', function() {
    const selectedValue = document.querySelector('input[name="properties[תדירות]"]:checked').value;
    const hiddenInput = document.querySelector('input[name="properties[Subscription interval]"]');

    if (selectedValue === "רכישה חד פעמית") {
      // Remove hidden input if present
      if (hiddenInput) {
        hiddenInput.remove();
      }
    } else if (selectedValue === "מנוי") {
      // Add hidden input if not present
      if (!hiddenInput) {
        const formId = document.getElementById('my-form-id').value;
        const newInput = document.createElement('input');
        newInput.type = 'hidden';
        newInput.name = 'properties[Subscription interval]';
        newInput.value = '';
        newInput.setAttribute('form', formId);
        // Append to the form or any valid parent
        radio.form.appendChild(newInput);
      }
    }
  });
});
document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.one-time-fee, .subscription').forEach(function(container) {
    container.addEventListener('click', function(event) {
      // Only fire if you didn't directly click the radio
      if (event.target.tagName.toLowerCase() !== 'input') {
        let input = container.querySelector('input[type="radio"]');
        if (input) {
          input.checked = true;
          // Optionally trigger change event if necessary
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    });
  });
});
  } catch(e) { console.error(e); }
})();

})();
